import EventEmitter from '@/lib/socket.io-plugin/emitter';
import Vue from 'vue';
import Vuex, { ActionContext } from 'vuex';
import modules from '@/store/index';

Vue.use(Vuex);

export interface RootState {
  isSocketConnected: boolean,
}

const store = new Vuex.Store<RootState>({
  modules,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    isSocketConnected: false
  },
  actions: {
    async handleSocketEvents({ dispatch }: ActionContext<RootState, RootState>, events: { eventName: string, params: any }[]) {
      const eventEmitter = new EventEmitter({
        store,
        actionPrefix: '',
        mutationPrefix: ''
      });

      for (let index = 0; index < events.length; index++) {
        eventEmitter.dispatchStore(events[index].eventName, events[index].params);
      }
    },
  },
  mutations: {
    socketConnect(state) {
      state.isSocketConnected = true;
    },
    socketDisconnect(state) {
      state.isSocketConnected = false;
    },
  },
});

export default store;
